
import { Box, Stack } from "@mui/material";
import { DailyLivingActivitiesSection } from "./components/DailyLivingActivitiesSection";
import { SensoryAndCommunicationSection } from "./components/SensoryAndCommunicationSection";
import { SystemsAssessmentSection } from "./components/SystemsAssessmentSection";

//YATAY;452641;18042025
function PageFive() {
  return (
    <Box sx={{ p: 2 }}>
      <Stack spacing={4}>
        <DailyLivingActivitiesSection />
        <SensoryAndCommunicationSection />
        <SystemsAssessmentSection />
      </Stack>
    </Box>
  );
}

export default PageFive;
